import {Button, Card, CardActions, CardContent, CardHeader, Grid} from '@material-ui/core';
import {makeStyles} from '@material-ui/core/styles';
import React, {useEffect, useState} from 'react';
import {useDispatch} from 'react-redux';
import {getFirstUser, postLogin} from '../../Redux/actions';
import {TextInputField} from '../Common/HelperInputFields';
import {A, navigate} from 'hookrouter';

const useStyles = makeStyles(theme => ({
    formTop: {
        marginTop: '100px',
    },
    pdLogo: {
        height: '345px',
        border: 'solid 3px white'
    }
}));

const Login = () => {
    const classes = useStyles();
    const dispatch: any = useDispatch();
    const initForm: any = {
        username: '',
        password: '',
    };
    const initErr: any = {};
    const [form, setForm] = useState(initForm);
    const [errors, setErrors] = useState(initErr);
    const [hasFirstUser, setFirstUser] = useState(true);
    const handleChange = (e: any) => {
        const {value, name} = e.target;
        const fieldValue = Object.assign({}, form);
        const errorField = Object.assign({}, errors);
        if (errorField[name]) {
            errorField[name] = null;
            setErrors(errorField);
        }
        fieldValue[name] = value;
        if (name === 'username') {
            fieldValue[name] = value.toLowerCase();
        }
        setForm(fieldValue);
    };
    useEffect(() => {
        dispatch(getFirstUser()).then((resp: any) => {
            setFirstUser(resp.data.hasUser);
        });
    }, [dispatch]);

    const validateData = () => {
        let hasError = false;
        const err = Object.assign({}, errors);
        if (!/^(([^<>()[\]{}'^?\\.,!|//#%*-+=&;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/.test(form.username)) {
            hasError = true;
            err.username = 'Enter a valid email.';
        }
        Object.keys(form).forEach((key) => {
            if (typeof (form[key]) === 'string' && key !== 'password' && key !== 'confirm') {
                if (!form[key].match(/\w/)) {
                    hasError = true;
                    err[key] = 'This field is required';
                }
            }
            if (!form[key]) {
                hasError = true;
                err[key] = 'This field is required';
            }
        });
        if (hasError) {
            setErrors(err);
            return false;
        }
        return form;
    };

    const handleSubmit = (e: any) => {
        e.preventDefault();
        const valid = validateData();
        if (valid) {
            dispatch(postLogin(valid)).then((resp: any) => {
                const res = resp && resp.data;
                if (res.success) {
                    localStorage.setItem('fairsettle_access_token', res.access_token);
                    navigate('/dashboard');
                    window.location.reload();
                }
                else {
                    const err = {
                        password: 'Username or Password incorrect',
                    };
                    setErrors(err);
                }
            });
        }
    };

    return (
        <div>
            <Grid container className={classes.formTop} spacing={2} justify="flex-end">
                <Grid item xs={12} sm={5} md={4} lg={3}>
                    <Card>
                        <CardHeader title="Login"/>
                        <form onSubmit={(e) => handleSubmit(e)}>
                            <CardContent>
                                <TextInputField
                                    name="username"
                                    placeholder="Email"
                                    variant="outlined"
                                    margin="dense"
                                    value={form.username}
                                    onChange={handleChange}
                                    errors={errors.username}
                                />
                                <TextInputField
                                    type="password"
                                    name="password"
                                    placeholder="Password"
                                    variant="outlined"
                                    margin="dense"
                                    value={form.password}
                                    onChange={handleChange}
                                    errors={errors.password}
                                />
                            </CardContent>

                            <CardActions className="padding16">
                                <A href="/forgot-password">Forgot password?</A>
                                <Button
                                    color="primary"
                                    variant="contained"
                                    type="submit"
                                    style={{marginLeft: 'auto'}}
                                    onClick={(e) => handleSubmit(e)}
                                >Login
                                </Button>
                            </CardActions>
                        </form>
                        {!hasFirstUser &&
                        <CardContent className="alignCenter">
                            You don't have an account? <A href="/register">Register</A>
                        </CardContent>
                        }
                    </Card>

                </Grid>
            </Grid>
        </div>
    );
};

export default Login;
